import React from 'react';
import { IRiderDetail } from '../../models/IRider';
import { Avatar, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DateHelperInstance from '../../services/DateHelper';
interface ParticipantSummaryProps {
    rider?: IRiderDetail;
}
function ParticipantSummary(props: ParticipantSummaryProps) {
    const { t } = useTranslation("common");
    const { rider } = props;

    return (
        <React.Fragment>
            <Grid container alignItems="center" spacing={3}>
                <Grid item xs>
                    <Avatar src={rider?.riderAvatarUrl} alt={rider?.name} />
                    <Typography gutterBottom variant="h4">
                        {rider?.name}
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.bestToday")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.bestTime}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.average")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.averageTime}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.bestGroup")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.groupBest !== undefined ? DateHelperInstance.millisToMinutesSecondsAndMilliseconds(rider.groupBest) : '-'}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.bestEvent")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.eventBest !== undefined ? DateHelperInstance.millisToMinutesSecondsAndMilliseconds(rider.eventBest) : '-'}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.bestCircuit")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.circuitBest !== undefined ? DateHelperInstance.millisToMinutesSecondsAndMilliseconds(rider.circuitBest) : '-'}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item >
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.gapBestOfGroup")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.gapBestGroup}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.gapBestOfDay")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.gapBest}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {t("rider.gapBestOfCircuit")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography gutterBottom variant="h6">
                            {rider?.gapCircuitBest}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment >);
}

export default ParticipantSummary;